import { graphql } from '@data-access/graphql'

const _AccommodationAvailableDateFragmentDoc = graphql(`
  fragment AccommodationAvailableDate on AccommodationAvailableDate {
    date
    price
    minLengthOfStay
  }
`)

export const AvailableDatesDocument = graphql(`
  query availableDates($input: AccommodationAvailableDatesInput!) {
    availableDates(input: $input) {
      ...AccommodationAvailableDate
    }
  }
`)
